import { IEarlyAccess } from '../../types/earlyAccess';
import { ResponseError } from 'shared/errors';
import {
  TPublicWebV1GetSearchBannerResponse,
  fetchPublicWebV1GetSearchBanner,
} from 'shared/repositories/early-access/web/v1/get-search-banner';
import { IApplicationContext } from 'shared/types/applicationContext';

export async function fetchEarlyAccessData({ logger, httpApi }: IApplicationContext): Promise<IEarlyAccess | null> {
  try {
    const { response, statusCode }: TPublicWebV1GetSearchBannerResponse = await fetchPublicWebV1GetSearchBanner({
      httpApi,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchEarlyAccessData',
        message: response.message || 'Не удалось получить информацию для баннера раннего доступа',
        details: {
          error: JSON.stringify(response.errors),
        },
      });
    }

    return response;
  } catch (ex) {
    logger.warning(ex, { degradation: 'Информация для баннера раннего доступа' });

    return null;
  }
}
